import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AiButtonIcon from './ai-button-icon';
import AiChatPanel from './ai-chat-panel';
import constants, { DISPLAY_MODES } from '../constants/common';

const { IFRAME_TITLE } = constants;

const AiChat = ({
  url,
  siteId,
  isOpen,
  displayMode,
  isMainMenuOpen = false,
  onTriggerClick,
  triggerRef,
  panelRef,
  iframeRef,
}) => {
  const isTriggerVisible = !(isOpen && displayMode === DISPLAY_MODES.RIGHT);

  const triggerClassName = classNames('ws-ai-chat', {
    'ws-ai-chat--under-nav-overlay': isMainMenuOpen,
  });

  return (
    <React.Fragment>
      {isTriggerVisible && (
        <div className={triggerClassName} ref={triggerRef}>
          <button
            type="button"
            className="ws-ai-chat__trigger"
            aria-label={IFRAME_TITLE}
            aria-expanded={isOpen}
            onClick={onTriggerClick}
          >
            <AiButtonIcon className="ws-ai-chat__icon" />
          </button>
        </div>
      )}
      <AiChatPanel
        ref={panelRef}
        url={url}
        siteId={siteId}
        isOpen={isOpen}
        displayMode={displayMode}
        isMainMenuOpen={isMainMenuOpen}
        iframeRef={iframeRef}
      />
    </React.Fragment>
  );
};

AiChat.propTypes = {
  url: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  displayMode: PropTypes.oneOf(Object.values(DISPLAY_MODES)).isRequired,
  isMainMenuOpen: PropTypes.bool,
  onTriggerClick: PropTypes.func.isRequired,
  triggerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  panelRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  iframeRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
};

export default AiChat;
